<footer class="footer bg-primary text-secondary">
  <div class="container-fluid">
    <span>&copy; {{ 'ALL_RIGHTS_RESERVED' | translate }}</span>
  </div>
</footer>
